<template>
  <v-container grid-list-xl>
    <div class="vue-contentido">
        <v-card >
            <v-card-title :style="{background:'#1565c0',color:'white'}">
                <v-layout row>
                    <v-flex xs12 sm11 md11>
                        <p v-if="gindicador">{{gindicador.codigo}} {{gindicador.nombre}} - Avance de gestión {{this.avancegestion}}%</p>
                    </v-flex>
                    <v-flex xs12 sm1 md1>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                dark
                                color="white"
                                v-on="on"
                                @click="cambiarhito=true"
                                >
                                <v-icon dark color="black">list</v-icon>
                                </v-btn>
                            </template>
                            <span>Cambiar hito</span>
                        </v-tooltip>
                        <v-dialog v-model="cambiarhito" width="900" persistent>
                            <v-card>
                                <v-card-title>
                                <v-btn
                                    color="primary"
                                    text
                                    @click="cambiarhito=false"
                                >Cerrar</v-btn>
                                <v-spacer></v-spacer>
                                </v-card-title>
                                <v-card-text>
                                <div v-if="ghito">
                                    <v-data-table
                                    :no-data-text="gnodata"
                                    :headers="HeaderHitos"
                                    :items="ghito"
                                    class="elevation-2"
                                    hide-default
                                    :items-per-page="10"
                                    >
                                    <template
                                      v-slot:item.fechacumplimiento="{ item }"
                                    >{{formato(item.fechacumplimiento)}}</template>
                                    <template v-slot:item.cumplido="{ item }">
                                      <div v-if="item.cumplido === true && item.idestado == 6">Sí</div>
                                      <div v-else>No</div>
                                    </template>
                                    <template v-slot:item.action="{ item }">
                                      <div v-if="item.idestado == 6 || (item.cumplido === false && item.hitoaprobado)">
                                        <v-icon small class="mr-2" @click="cargarhito(item)">remove_red_eye</v-icon>
                                      </div>
                                      <div v-else>
                                        <v-tooltip bottom>
                                          <template v-slot:activator="{ on }">
                                            <v-icon small color="red" class="mr-2" v-on="on">mdi-eye</v-icon>
                                          </template>
                                          <span>No se cuenta con detalle del hito</span>
                                        </v-tooltip>
                                      </div>
                                    </template>
                                  </v-data-table>
                                </div>
                                </v-card-text>
                            </v-card>
                            </v-dialog>
                        
                    </v-flex>
                </v-layout>
            </v-card-title>
            <v-card-text v-if="hito">
                <v-spacer></v-spacer>
                 <v-layout row>
                     <v-flex xs12 sm12 md12>
                         <v-card>
                             <v-card-title :style="{color:'black'}">
                                 <p class="title">Hito: {{this.hito.descripcion}}</p>
                             </v-card-title>
                         </v-card>
                     </v-flex> 
                 </v-layout>
                <v-spacer></v-spacer>
                <v-layout row>
                    <v-flex xs12 sm3 md3>
                        Hay cumplimiento del Hito *
                        <v-radio-group
                        row
                        v-model="this.hito.cumplido"
                        :readonly="true"
                        >
                        <v-radio label="si" :value="true"></v-radio>
                        <v-radio label="no" :value="false"></v-radio>
                        </v-radio-group>
                    </v-flex>
                    <v-flex xs12 sm2 md2>
                        Ponderación: {{this.hito.ponderacion}} %
                    </v-flex>
                    <v-flex xs12 sm4 md4>
                        Fecha estimada de cumplimiento: {{formato(this.hito.fechacumplimiento)}} 
                    </v-flex>
                    <v-flex xs12 sm3 md3>
                        Fecha de cumplimiento: <div v-if="this.hito.cumplido === true">{{formato(this.hito.fechamodificacion)}} </div>
                    </v-flex>
                </v-layout>
                <v-layout row v-if="this.hito.cumplido === true">
                     <v-flex xs12 sm12 md12>
                         <v-card flat v-if="this.hito.idestado == 6">
                             <v-card-title>
                                Avance - {{formato(this.hito.fechamodificacion)}}               
                             </v-card-title>
                             <v-card-text>
                               <div v-html="cambiarenter(this.hito.observacion)"></div>}
                             </v-card-text>
                         </v-card>
                    </v-flex>
                </v-layout>
                <v-layout row v-if="this.hito.idestado !==6 && this.hito.cumplido === false && this.hito.hitoaprobado">
                  <v-flex xs12 sm12 md12>
                        <v-card flat>
                          <v-card-title>
                            Razón del incumplimiento - {{formato(this.hito.fechamodificacion)}}        
                          </v-card-title>
                          <v-card-text>
                             <div v-html="cambiarenter(this.hito.incumplimiento)"></div>
                          </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
                <div v-if="hitoExportar != null" id="div1">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-flex sm1 offset-sm11>
                      <download-excel
                        id="div2"
                        style="width: 100%; text-align: right"
                        v-show="hitoExportar.length > 0"
                        class="btn btn-default"
                        :data="hitoExportar"
                        :exportFields="exportableHito"
                        name="Hito.xls"
                        type="xls"
                        worksheet="Información"
                      >
                        <v-icon
                          color="secondary"
                          v-on="on"
                          large
                          elevation="2"
                          >mdi-file-download-outline</v-icon
                        >
                      </download-excel>
                      </v-flex>
                    </template>
                    <span>Descargar</span>
                  </v-tooltip>
                </div>
            </v-card-text>
        </v-card>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import _ from 'lodash';
export default {
  name: "detallehito",
  data() {
    return {
      hitoExportar: [],
      hito: null,
      idhito: null,
      idindicador: null,
      cambiarhito:false,
      avancegestion: 0,
      HeaderHitos: [
        {
          text: "Descripción",
          value: "descripcion",
          align: "justify",
          width: "50%"
        },
        {
          text: "Ponderación (%)",
          value: "ponderacion",
          align: "center",
          width: "20%"
        },
        {
          text: "Fecha estimada de cumplimiento",
          value: "fechacumplimiento",
          align: "center",
          width: "20%"
        },
        { text: "Cumplido", value: "cumplido", sortable: false, width: 100 },
        { text: "Detalle", value: "action", sortable: false, align: "center" }
      ],
      exportableHito: 
      {
        "Código indicador": "codigo",
        "Nombre indicador": "nombre",
        "Descripción hito": "descripcion",
        "Fecha estimada de cumplimiento hito": "fechacumplimiento",
        "Ponderación hito": "ponderacion",
        "Fecha de cumplimiento hito":"fechamodificacion",
        "Hito cumplido":"cumplido",
        "Avance hito":"observacion",
        "Razón incumplimiento":"incumplimiento"
      }
      
    }
  },
  methods: {
    ...mapActions([
      "Indicador_Encabezado",
      "Gethitos",
      "gethitobyid"
    ]),
    usuario() {
      if(localStorage.usuario)
        return JSON.parse(unescape(localStorage.usuario));
      else
        return null;
    },
    formato(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
    cargarhito(item)
    {
        this.gethitobyid({
            params: {
                idhito: item.idhito
            }
        });
        this.cambiarhito = false;
    },
    cambiarenter(cadena)
    {
     if (cadena !== null )
     {
      let otro =  cadena.replace(/\n/g, "<br>");
     
      return otro;
     }
    },
  },
  computed: {
    ...mapGetters([
      "gindicador",
      "ghito",
      "gindicadorhito"
    ]),
    ...mapGetters("mensaje", ["ginformation", "gnodata"]),
    ...mapGetters("usuario", ["gusuario", "gusuarios"])
    // ...mapGetters("carga", ["gerrorcarga"])
  },
  created() {
    this.hitoExportar = this.gindicadorhito.hito;
    this.cargando = true;
    let getUser = this.usuario();
    if (getUser != undefined)
    {
      if (getUser.usuarioRol.length > 0)
        this.idrol = getUser.usuarioRol[0].idrol
    }
    let global = JSON.parse(unescape(process.env.PACKAGE_JSON)).global;
    let env = global[global.env];
    this.$aes.setKey(env.path.secret);
    let temporal = this.$route.params.idhito.replace(/AbcYq/g, "/");
    temporal = temporal.replace(/qYcbA/g, "+");
    temporal = this.$aes.decrypt(temporal);
    temporal = temporal.substring(4);
    temporal = temporal.substring(0, temporal.length - 4);
    temporal = this.$aes.decrypt(temporal);
    this.idhito = temporal;
    this.gethitobyid({
      params: {
        idhito: this.idhito
      }
    });
    
  },
  watch: {
      gindicadorhito: function() {
          this.hitoExportar = _.cloneDeep(this.gindicadorhito.hito);
          if(this.hitoExportar[0].cumplido && this.hitoExportar[0].idestado == 6)
           this.hitoExportar[0].cumplido='si';
          else 
            this.hitoExportar[0].cumplido='no';
          
          this.hitoExportar[0].codigo = this.gindicadorhito.codigo;
          this.hitoExportar[0].nombre = this.gindicadorhito.nombre;
          
            this.hitoExportar[0].fechacumplimiento = this.formato(this.hitoExportar[0].fechacumplimiento);
         
          if(this.hitoExportar[0].cumplido == 'si')
            this.hitoExportar[0].fechamodificacion = this.formato(this.hitoExportar[0].fechamodificacion);
          else if(this.hitoExportar[0].cumplido == 'no')
            this.hitoExportar[0].fechamodificacion = "";
          this.hitoExportar[0].ponderacion = this.hitoExportar[0].ponderacion + "%";
          
          this.hito = this.gindicadorhito.hito[0];
          this.hito.cumplido = this.hito.cumplido && this.hito.idestado == 6;
          this.idindicador = this.gindicadorhito.idindicador;

          this.Indicador_Encabezado({
            params: {
                idindicador: this.idindicador
            }
          });
          this.Gethitos({
            params: {
                idindicador: this.idindicador
            }
          });
      },
      ghito: function(){
        this.avancegestion = _.sumBy(_.filter(this.ghito, {'idestado': 6, 'cumplido': true}), 'ponderacion');
      }
  }
}
</script>